import { CR_API_ENDPOINTS, QUERY_PARAMS, STATUS_FILTER_VALUES } from '../constants';
import { Attachment } from '../types';
import { apiService } from './api.service';

class AttachmentsService {
  async getAllAttachments(status: string = STATUS_FILTER_VALUES.ALL): Promise<Attachment[]> {
    const params = { [QUERY_PARAMS.STATUS]: status };
    return apiService.get<Attachment[]>(CR_API_ENDPOINTS.ATTACHMENTS, params);
  }

  async getActiveAttachments(): Promise<Attachment[]> {
    const params = { [QUERY_PARAMS.STATUS]: STATUS_FILTER_VALUES.ACTIVE };
    return apiService.get<Attachment[]>(CR_API_ENDPOINTS.ATTACHMENTS, params);
  }

  async getAttachmentById(id: string): Promise<Attachment> {
    return apiService.get<Attachment>(`${CR_API_ENDPOINTS.ATTACHMENTS}/${id}`);
  }

  async createAttachment(attachmentData: {
    name: string;
  }): Promise<Attachment> {
    try {
      return await apiService.post<Attachment>(CR_API_ENDPOINTS.ATTACHMENTS, attachmentData);
    } catch (error) {
      throw new Error(`Failed to create attachment: ${error}`);
    }
  }
}

export const attachmentsService = new AttachmentsService();